import React from 'react';
import {Link} from "react-router-dom";
import "./ApiCatalogCard.scss"

const ApiCatalogCard = (props) => {

    const {apis, value, chipData, saveApiSelection, saveApiTabSelection} = props;

    const onFilter = (item) => {
        let result = true;

        if (!value && chipData.length === 0) {
            return true;
        }

        if (value) {
            const regexp = RegExp(value, 'gi');
            result = regexp.test(
                [
                    item.name,
                    item.framework,
                    item.progress,
                    item.details
                ]
                    .filter((a) => a)
                    .join(''),
            );
        }

        if (result && chipData && chipData.length > 0) {
            result = chipData.every((chip) => {
                const regexp = RegExp(chip.label, 'gi');
                return regexp.test(
                    [
                        item.name,
                        item.framework,
                        item.progress,
                        item.details
                    ]
                        .filter((a) => a)
                        .join(''),
                );
            });
        }

        return result;
    }

    const handleClick = (api, apiTab) => {
        saveApiSelection(api);
        saveApiTabSelection(apiTab)
    }

    const handleDownloadClick = (api) => {
        const url = `${window.portalBaseUrl}/documentation/${Object.values(api.versions)[0].staticResource.documentation}`;
        window.open(url, '_blank').focus();
    }

    return (
        <div className={"api-catalog-card-container-parent"}>
            {apis.length > 0 ?
                apis.filter((api) => onFilter(api)).map((api) => {
                    return <div key={api.name} className={"api-catalog-card-container"}>
                        <span className={"api-catalog-card-title"}>{api.name}</span>
                        <div className={"api-catalog-content-container-parent"}>
                            <div className={"api-catalog-content-container-left"}>
                                <span className={"api-catalog-content-left-framework"}>{api.framework}</span>
                                <span className={"api-catalog-content-left-progress"}>{api.progress}</span>
                            </div>
                            <div className={"api-catalog-content-container-right"}>
                                <Link to="/overview" style={{marginTop: "-5px"}} className="btn btn-small btn-green-hover" onClick={() => handleClick(api, "Overview")}>
                                    <span className={"link-text"}>Overview</span>
                                </Link>
                                <Link to="/overview" style={{marginTop: "-5px"}} className="btn btn-small btn-green-hover" onClick={() => handleClick(api, "Documentation")}>
                                    <span className={"link-text"}>Documentation</span>
                                </Link>
                                <button style={{marginTop: "-5px"}} className="btn btn-small btn-green-hover" onClick={() => handleDownloadClick(api)}>
                                    <span className={"link-text"}>Download Swagger</span>
                                </button>
                            </div>
                        </div>
                        <div className={"api-catalog-details-container"}>
                            {api.details.length > 0 ?
                                api.details.map((detail) => {
                                    return <span key={crypto.randomUUID()} className={"api-catalog-details-text"}>{detail}</span>
                                }) : null}
                        </div>
                    </div>
                }) : null
            }
        </div>
    );
};

export default ApiCatalogCard;
